module.exports = __webpack_public_path__ + "static/media/shinjuku_3.985c7a12.png";